import { ZERO_ADDRESS, CHAIN_ID_ETHEREUM, CHAIN_ID_ZCHAIN, CHAIN_ID_SEPOLIA, CHAIN_ID_ZEPHYR } from './constants';

export interface CuratedToken {
  tokenAddress: string;
  symbol: string;
  name: string;
  decimals: number;
  logo?: string;
  isNative?: boolean;
}

export const SUPPORTED_BRIDGE_TOKENS = ['WILD', 'mUSDC', 'USDC'];

export function isSupportedBridgeToken(symbol: string): boolean {
  return SUPPORTED_BRIDGE_TOKENS.includes(symbol);
}

export const CURATED_TOKENS: Partial<Record<number, CuratedToken[]>> = {
  [CHAIN_ID_ETHEREUM]: [
    {
      tokenAddress: ZERO_ADDRESS,
      symbol: 'ETH',
      name: 'Ether',
      decimals: 18,
      isNative: true,
    },
    {
      tokenAddress: '0x2a3bFF78B79A009976EeA096a51A948a3dC00e34',
      symbol: 'WILD',
      name: 'Wilder',
      decimals: 18,
      logo: '/tokens/wild.png',
    },
  ],
  [CHAIN_ID_ZCHAIN]: [
    {
      tokenAddress: ZERO_ADDRESS,
      symbol: 'Z',
      name: 'Z',
      decimals: 18,
      isNative: true,
    },
    {
      tokenAddress: '0x376F41Bb278253457A0073e0ce93Ec457F09fc00',
      symbol: 'WILD',
      name: 'Wilder',
      decimals: 18,
      logo: '/tokens/wild.png',
    },
  ],
  [CHAIN_ID_SEPOLIA]: [
    {
      tokenAddress: ZERO_ADDRESS,
      symbol: 'SepoliaETH',
      name: 'SepoliaETH',
      decimals: 18,
      isNative: true,
    },
    {
      tokenAddress: '0xAED26A7997802e13288f2fF1278fD618C92D1659',
      symbol: 'mUSDC',
      name: 'Mock USDC',
      decimals: 18,
    },
  ],
  [CHAIN_ID_ZEPHYR]: [
    {
      tokenAddress: ZERO_ADDRESS,
      symbol: 'Z',
      name: 'Z',
      decimals: 18,
      isNative: true,
    },
    {
      tokenAddress: '0xE70D44453583485155Cb80a8d122A7d52c4e11a5',
      symbol: 'mUSDC',
      name: 'Mock USDC',
      decimals: 18,
    },
  ],
};
